module.exports = __webpack_public_path__ + "img/hy.388ca7e1.png";